import { render, staticRenderFns } from "./Assigned.vue?vue&type=template&id=5ecbc328&"
import script from "./Assigned.vue?vue&type=script&lang=js&"
export * from "./Assigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports